module.exports = __webpack_public_path__ + "static/media/pharmacy1-300.dd940876.webp";